// extracted by mini-css-extract-plugin
export default {"root":"TfGrpjWFKZQd3jhGhgHW","overlay":"KbciIlytOk1zLr1kmaOw","video":"WwEYucEXcQDNR42Ya8vg"};